"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPasswordPolicy = void 0;
/**
 * Get password policy
 */
var getPasswordPolicy = function (instance) { return function (config) {
    return instance.get("/users/password-policy", config);
}; };
exports.getPasswordPolicy = getPasswordPolicy;
